import axios from 'axios';
import React from 'react';
import { Notification } from '@eds/vanilla';

const url = "https://in.01.singlepaneofglass.ericsson.net/backend";

// Modify the default Axios instance
axios.defaults.baseURL = `${url}/api`;
axios.defaults.headers.common['X-Timezone'] =
  Intl.DateTimeFormat().resolvedOptions().timeZone;
axios.defaults.headers.common['X-GMT-Offset'] = `GMT${
  new Date().getTimezoneOffset() > 0 ? '-' : '+'
}${String(Math.floor(Math.abs(new Date().getTimezoneOffset()) / 60)).padStart(
  2,
  '0'
)}.${String(Math.abs(new Date().getTimezoneOffset()) % 60).padStart(2, '0')}`;

// Set up Axios interceptors for error handling
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    // Display the notification for the error
    const notification = new Notification({
      title: 'Error',
      description: error.message,
      icon: 'icon-error',
      stripeColor: 'red',
      timeout: 5000,
      action: () => {
        //console.log('Console log show when clicked on dynamic notification.');
      }
    });

    notification.init();

    return Promise.reject(error);
  }
);

export default axios;
